export default function latestNewsReducer(state = {
    latestNews: [],
    fetching: false,
    fetched: false
  }, action) {
    switch (action.type) {
      case 'GET_LATEST_NEWS_PENDING': {
        return {
          ...state,
          fetching: true,
          fetched: false
        }
      }
      case 'GET_LATEST_NEWS_FULFILLED': {
        return {
          ...state,
          fetching: false,
          fetched: true,
          latestNews: action.payLoad.data
        }
      }
      case 'GET_LATEST_NEWS_REJECTED': {
        return {
          ...state,
          errors: action.payLoad.errors
        }
      }
      default:
    }
  
    return {...state};
  }


// WEBPACK FOOTER //
// ./src/reducers/latestNewsReducer.js